import { useQuery } from '@tanstack/react-query';
import { callGetMyStores } from '@/lib/firebase';
import { queryKeys } from '@/lib/queryClient';
import type { StoreModel } from '@molish-gym/shared';

async function fetchMyStores(): Promise<StoreModel[]> {
  const result = await callGetMyStores({});
  return result.data ?? [];
}

/**
 * Stores owned by the current user (`getMyStores` callable).
 */
export function useMyStoresQuery(userId: string | undefined) {
  return useQuery({
    queryKey: userId ? queryKeys.store.myStores(userId) : ['store', 'my', 'none'],
    queryFn: fetchMyStores,
    enabled: Boolean(userId),
  });
}
